// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"C1-z","subtitle":"D1-z","wrapper":"E1-z","leftArrow":"F1-z","rightArrow":"G1-z"};